(function () {
  'use strict';

  angular
    .module('neo.home.referees')
    .controller('RefereesCtrl', RefereesCtrl);

  function RefereesCtrl($timeout, $mdDialog, $mdToast, $q, $http, townHalls, $filter, AclService, RefereeList, receptores, InvoiceRef, InvoiceRefLine, Configuracio, Distancies, EnvironmentConfig, $state) {
    var vm = this;
    vm.ctrlName = 'RefereesCtrl';
    vm.isAjuntament = AclService.isAjuntament();

    var organisationList;
    if (AclService.isAdmin()) {
      organisationList = angular.copy(townHalls);
      organisationList.push({ name: $filter('translate')('COUNCIL'), id: undefined });
    } else if (AclService.isAjuntament()) {
      var allowed = AclService.getAllowedAjuntamentIds();
      organisationList = angular.copy(townHalls).filter(function (o) {
        return allowed.indexOf(o.id) !== -1;
      });
    } else {
      organisationList = [];
    }

    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'ACTIONS',
      actions: [{
        icon: 'add',
        tooltip: 'Afegir',
        execute: add
      }, {
        icon: 'timer',
        tooltip: 'Partits arbitrats',
        execute: partits
      }, {
        icon: 'local_atm',
        tooltip: 'Veure factures',
        execute: veurefactures
      }, {
        icon: 'filter_3',
        tooltip: 'Resum trimestral',
        execute: resumtrimestral
      }]
    };

    function veurefactures()  { $state.go('home.invoicesgroup'); }
    function resumtrimestral(){ $state.go('home.invoicestrimestral'); }
    function add()            { $state.go('home.referees.newReferee'); }
    function partits()        { $state.go('home.invoiceslist'); }

    vm.data = {
      title: 'REFEREES.LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        { id: 'name',         name: 'NAME',                     canOrder: true, orderBy: 'nameOrder' },
        { id: 'surname',      name: 'SURNAME',                  canOrder: true, orderBy: 'surnameOrder', orderDesc: true },
        { id: 'organisation', name: 'RESPONSIBLE_ORGANISATION', canOrder: true }
      ],
      areRowsClickable: true,
      state: {
        slink: 'home.referees.referee',
        params: [{ key: 'licenseId', value: 'id' }]
      },
      defaultOrderBy: 'nameOrder',
      filters: [{
        label: 'REFEREES.SELECT_TOWNHALL_OR_COUNCIL',
        showField: 'name',
        filterParam: 'organisationId',
        filterField: 'id',
        required: true,
        options: organisationList
      }],
      filterPromise: function (params) {
        var queryObject = { council: false, organisationId: params.organisationId };
        if (angular.isUndefined(params.organisationId) || _.isNull(params.organisationId)) {
          queryObject = { council: true, organisationId: null };
        }
        return RefereeList.query(queryObject).$promise;
      },
      filterFunction: function (data) {
        var persons = [];
        angular.forEach(data, function (licence) {
          persons.push({
            id:           licence.id,
            organisation: _.isNull(licence.organisationName) ? $filter('translate')('COUNCIL') : licence.organisationName,
            name:         licence.person.name,
            nameOrder:    $filter('lowercase')(licence.person.name),
            surname:      licence.person.surname,
            surnameOrder: $filter('lowercase')(licence.person.surname)
          });
        });
        return persons;
      }
    };

    // ─── Importació Excel de facturació ───────────────────────────────────────

    var EXPECTED_HEADERS = [
      'MES',
      'Nom',
      'Cognom',
      'Municipi',
      'Data',
      'Núm Partits',
      'Municipi arbitratge',
      'Categoria',
      'Modalitat',
      'Distància',
      'Preu partit net',
      'Preu partit brut',
      'Desplaçament',
      'SUBTOTAL',
      'Total net',
      'IRPF',
      'Nº Factura',
      'Pagament'
    ];

    var CEBLLOB_RECEPTOR_ID = 1;

    vm.handleExcelFile = function (inputEl) {
      var file = inputEl.files[0];
      inputEl.value = '';
      if (!file) { return; }
      var reader = new FileReader();
      reader.onload = function (e) {
        $timeout(function () { processWorkbook(e.target.result); });
      };
      reader.readAsArrayBuffer(file);
    };

    // ─── Processament intern ──────────────────────────────────────────────────

    function processWorkbook(arrayBuffer) {
      var workbook;
      try {
        workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' });
      } catch (err) {
        alertDialog('Error de lectura', 'No s\'ha pogut llegir el fitxer Excel: ' + err.message);
        return;
      }

      var sheetNames = workbook.SheetNames;
      if (sheetNames.length > 1) {
        selectSheet(sheetNames).then(function (name) { validateSheet(workbook, name); });
      } else {
        validateSheet(workbook, sheetNames[0]);
      }
    }

    function selectSheet(sheetNames) {
      var items = sheetNames.map(function (name, i) {
        return '<md-list-item ng-click="pick(' + i + ')" style="cursor:pointer"><p>' +
               escHtml(name) + '</p></md-list-item>';
      }).join('');

      return $mdDialog.show({
        template:
          '<md-dialog style="min-width:320px">' +
          '<md-toolbar><div class="md-toolbar-tools">' +
          '<md-icon>table_chart</md-icon>' +
          '<h2 style="margin-left:8px">Selecciona el full de treball</h2>' +
          '</div></md-toolbar>' +
          '<md-dialog-content class="md-padding">' +
          '<p>El fitxer conté <strong>' + sheetNames.length + ' fulls</strong>. ' +
          'Selecciona el que vols validar:</p>' +
          '<md-list>' + items + '</md-list>' +
          '</md-dialog-content>' +
          '<md-dialog-actions>' +
          '<md-button ng-click="cancel()">Cancel·lar</md-button>' +
          '</md-dialog-actions>' +
          '</md-dialog>',
        controller: function ($scope, $mdDialog) {
          $scope.pick   = function (i) { $mdDialog.hide(sheetNames[i]); };
          $scope.cancel = function ()  { $mdDialog.cancel(); };
        }
      });
    }

    function validateSheet(workbook, sheetName) {
      var sheet = workbook.Sheets[sheetName];
      var rows  = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
      var headerRow = (rows[0] || []).map(function (v) {
        return String(v === null || v === undefined ? '' : v).trim();
      });

      var errors = [];

      EXPECTED_HEADERS.forEach(function (expected, i) {
        var actual = headerRow[i] !== undefined ? headerRow[i] : '';
        if (actual !== expected) {
          errors.push({
            col:      colLetter(i) + '1',
            pos:      i + 1,
            expected: expected,
            actual:   actual || '(cel·la buida)'
          });
        }
      });

      for (var j = EXPECTED_HEADERS.length; j < headerRow.length; j++) {
        if (headerRow[j]) {
          errors.push({
            col:      colLetter(j) + '1',
            pos:      j + 1,
            expected: '(cap)',
            actual:   headerRow[j]
          });
        }
      }

      if (errors.length === 0) {
        previewRows(rows, sheetName);
      } else {
        showErrors(sheetName, errors);
      }
    }

    // ─── Previsualització de files ────────────────────────────────────────────

    function norm(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    }

    // Cache per evitar les 30+ queries en cada obertura del diàleg
    var _cachedRefOpts = null;
    var _cachedRecs    = null;
    var _cachedTarifes = null;
    var _cachedDistMtx = null;

    function loadLookups() {
      if (_cachedRefOpts && _cachedRecs && _cachedTarifes && _cachedDistMtx) {
        return $q.resolve({ refOpts: _cachedRefOpts, recs: _cachedRecs, tarifes: _cachedTarifes, distMtx: _cachedDistMtx });
      }

      var queries = {
        recs:       receptores.query().$promise,
        tarifes:    Configuracio.get().$promise,
        distancies: Distancies.query().$promise
      };
      queries['org_council'] = RefereeList.query({ council: true }).$promise;
      townHalls.forEach(function (th) {
        if (th.id) {
          queries['org_' + th.id] = RefereeList.query({ council: false, organisationId: th.id }).$promise;
        }
      });

      return $q.all(queries).then(function (data) {
        var seen = {}, allRefs = [];
        Object.keys(data).forEach(function (key) {
          if (key === 'recs' || key === 'tarifes' || key === 'distancies') { return; }
          (data[key] || []).forEach(function (r) {
            if (!seen[r.id]) { seen[r.id] = true; allRefs.push(r); }
          });
        });
        _cachedRecs = data.recs.slice().sort(function (a, b) {
          return String(a.nombre).localeCompare(String(b.nombre), 'ca');
        });
        _cachedRefOpts = allRefs.map(function (r) {
          return {
            id:          r.id,
            label:       r.person.name + ' ' + r.person.surname,
            normName:    norm(r.person.name),
            normSurname: norm(r.person.surname)
          };
        }).sort(function (a, b) { return a.label.localeCompare(b.label, 'ca'); });

        _cachedTarifes = data.tarifes;

        _cachedDistMtx = {};
        (data.distancies || []).forEach(function (d) {
          if (!_cachedDistMtx[d.originId]) { _cachedDistMtx[d.originId] = {}; }
          _cachedDistMtx[d.originId][d.destinationId] = d.distanceKm;
        });

        return { refOpts: _cachedRefOpts, recs: _cachedRecs, tarifes: _cachedTarifes, distMtx: _cachedDistMtx };
      });
    }

    // Converteix un valor de cel·la Excel (número serial o string) a moment
    function parseExcelDate(val) {
      if (typeof val === 'number') {
        return moment(new Date(Math.round((val - 25569) * 86400000)));
      }
      return moment(String(val), ['DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY']);
    }

    // Cerca l'ID d'ajuntament pel nom (insensible a majúscules i accents)
    function findTownHallId(name) {
      var n = norm(name);
      for (var i = 0; i < townHalls.length; i++) {
        if (norm(townHalls[i].name) === n) { return townHalls[i].id; }
      }
      return null;
    }

    // Retorna els km entre dos municipis usant la matriu (simètrica)
    function lookupDistKm(from, to, distMtx) {
      if (!from || !to || norm(to) === 'cebllob') { return 0; }
      var origId = findTownHallId(from);
      var destId = findTownHallId(to);
      if (!origId || !destId) { return 0; }
      if (distMtx[origId] && distMtx[origId][destId]) { return distMtx[origId][destId]; }
      if (distMtx[destId] && distMtx[destId][origId]) { return distMtx[destId][origId]; }
      return 0;
    }

    function previewRows(rows, sheetName) {
      loadLookups().then(function (cache) {
        var allRefOpts = cache.refOpts;
        var allRecs    = cache.recs;
        var tarifes    = cache.tarifes;
        var distMtx    = cache.distMtx;

        var rowModels = [];
        for (var i = 1; i < rows.length; i++) {
          var row = rows[i];
          if (!row || row.every(function (c) { return !c && c !== 0; })) { continue; }
          if (row.some(function (c) { return norm(String(c)).indexOf('total de partits') !== -1; })) { continue; }
          rowModels.push(buildRowModel(row, i + 1, allRefOpts, allRecs));
        }

        if (rowModels.length === 0) {
          alertDialog('Excel buit', 'El full no conté files de dades (a part de la capçalera).');
          return;
        }

        showPreviewDialog(rowModels, allRecs, sheetName, tarifes, distMtx);
      }, function () {
        alertDialog('Error de càrrega', 'No s\'ha pogut carregar la llista d\'àrbitres o receptors.');
      });
    }

    function buildRowModel(row, lineNum, allRefOpts, allRecs) {
      var nom            = String(row[1]  || '').trim();
      var cognom         = String(row[2]  || '').trim();
      var municipi       = String(row[3]  || '').trim();
      var municipiArbitr = String(row[6]  || '').trim();
      var modalitat      = String(row[8]  || '').trim();
      var distanciaFlag  = String(row[9]  || '').trim();
      // Preu unitari = Preu partit brut (col L) / Núm Partits (col F)
      var preuBrutTotal  = parseFloat(String(row[11] || '').trim().replace(',', '.'));
      var numPartsRaw    = parseFloat(String(row[5]  || '').trim().replace(',', '.'));
      var preu           = (!isNaN(preuBrutTotal) && !isNaN(numPartsRaw) && numPartsRaw !== 0)
        ? String(Math.round((preuBrutTotal / numPartsRaw) * 10000) / 10000)
        : '';
      var pagament       = String(row[17] || '').trim();

      var normNom    = norm(nom);
      var normCognom = norm(cognom);
      var matches = allRefOpts.filter(function (r) {
        return r.normName === normNom && r.normSurname === normCognom;
      });

      // single match → plain label; 0 or >1 matches → full sorted list
      var selectableRefs = matches.length !== 1 ? allRefOpts : null;

      var receptorFixed      = norm(pagament).indexOf('cebllob') !== -1;
      var selectedReceptorId = receptorFixed ? CEBLLOB_RECEPTOR_ID : null;

      // Si no és CEBLLOB, intenta detectar el receptor pel nom dins de la col R (Pagament).
      // Match: nom del receptor exacte o contingut a la col R. Si n'hi ha diversos
      // (p.ex. 'Torrelles' i 'UET Voleibol' tots dos hi caben), tria el de nom
      // normalitzat més llarg (més específic). Si hi ha empat de longitud, deixa-ho
      // sense autoseleccionar perquè l'usuari triï.
      if (!receptorFixed && allRecs && pagament) {
        var normPag = norm(pagament);
        var recMatches = allRecs.filter(function (r) {
          var n = norm(r.nombre);
          return n && (n === normPag || normPag.indexOf(n) !== -1);
        });
        if (recMatches.length > 0) {
          recMatches.sort(function (a, b) { return norm(b.nombre).length - norm(a.nombre).length; });
          var topLen = norm(recMatches[0].nombre).length;
          var topTied = recMatches.filter(function (r) { return norm(r.nombre).length === topLen; });
          if (topTied.length === 1) {
            selectedReceptorId = topTied[0].idReceptor;
          }
        }
      }

      // When paid by an entity, concatenate col G to give extra context
      var pagamentDisplay = receptorFixed
        ? pagament
        : (pagament + (municipiArbitr ? ' · ' + municipiArbitr : ''));

      return {
        lineNum:            lineNum,
        nom:                nom,
        cognom:             cognom,
        pagament:           pagamentDisplay,
        municipi:           municipi,
        municipiArbitr:     municipiArbitr,
        modalitat:          modalitat,
        distanciaFlag:      distanciaFlag,
        preu:               preu,
        fecha:              row[4],
        numPartits:         String(row[5] || '1').trim(),
        refereeMatches:     matches,
        selectableRefs:     selectableRefs,
        selectedRefereeId:  matches.length === 1 ? matches[0].id : null,
        singleMatch:        matches.length === 1 ? matches[0].label : null,
        noMatch:            matches.length === 0,
        receptorFixed:      receptorFixed,
        receptorLabel:      receptorFixed ? 'CEBLLOB' : '',
        selectedReceptorId: selectedReceptorId
      };
    }

    function showPreviewDialog(rowModels, allRecs, sheetName, tarifes, distMtx) {
      $mdDialog.show({
        template:
          '<md-dialog style="max-width:960px;width:95vw">' +

          // ── Toolbar (títol canvia segons la vista) ────────────────────────
          '<md-toolbar><div class="md-toolbar-tools">' +
          '<md-icon ng-if="!formView && !resultsView">preview</md-icon>' +
          '<md-icon ng-if="formView">{{isNewRec ? "add" : "edit"}}</md-icon>' +
          '<md-icon ng-if="resultsView">assignment_turned_in</md-icon>' +
          '<h2 style="margin-left:8px" ng-if="!formView && !resultsView">Previsualització — {{rows.length}} files · ' + escHtml(sheetName) + '</h2>' +
          '<h2 style="margin-left:8px" ng-if="formView">{{isNewRec ? "Nou receptor" : "Modificar receptor"}}</h2>' +
          '<h2 style="margin-left:8px" ng-if="resultsView">Resultat de la importació</h2>' +
          '<span flex></span>' +
          '</div></md-toolbar>' +

          // ── Vista LISTADO ─────────────────────────────────────────────────
          '<md-dialog-content class="md-padding" style="overflow-x:auto;overflow-y:auto;max-height:60vh" ng-if="!formView && !resultsView">' +
          '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead>' +
          '<tr style="background:#f5f5f5;border-bottom:2px solid #ddd">' +
          '<th style="padding:6px 8px;text-align:left">#</th>' +
          '<th style="padding:6px 8px;text-align:left">Nom / Cognom</th>' +
          '<th style="padding:6px 8px;text-align:left">Tutor de joc</th>' +
          '<th style="padding:6px 8px;text-align:center">idRef</th>' +
          '<th style="padding:6px 8px;text-align:left">Pagament</th>' +
          '<th style="padding:6px 8px;text-align:left">Receptor</th>' +
          '<th style="padding:6px 8px;text-align:center">idReceptor</th>' +
          '<th style="padding:6px 8px;text-align:left">Municipi</th>' +
          '<th style="padding:6px 8px;text-align:left">Municipi arb.</th>' +
          '<th style="padding:6px 8px;text-align:center" title="Introdueix \'c\' per calcular el desplaçament automàticament">Distància</th>' +
          '<th style="padding:6px 8px;text-align:center">✓</th>' +
          '<th style="padding:6px 8px"></th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          '<tr ng-repeat="row in rows" style="border-bottom:1px solid #eee">' +
          '<td style="padding:4px 8px;color:#888;white-space:nowrap">{{row.lineNum}}</td>' +
          '<td style="padding:4px 8px;white-space:nowrap">' +
          '<span ng-if="row.noMatch" title="Nom no trobat al registre" ' +
          'style="color:#e65100;margin-right:4px;vertical-align:middle">⚠</span>' +
          '{{row.nom}} {{row.cognom}}' +
          '</td>' +
          '<td style="padding:4px 8px">' +
          '<span ng-if="row.singleMatch" style="white-space:nowrap">{{row.singleMatch}}</span>' +
          '<md-select ng-if="!row.singleMatch" ng-model="row.selectedRefereeId" ' +
          'placeholder="Selecciona tutor" style="min-width:170px;margin:0" md-on-close="search.ref = \'\'">' +
          '<md-select-header>' +
          '<input ng-model="search.ref" type="search" placeholder="Cercar tutor…" ' +
          'ng-click="$event.stopPropagation()" ng-keydown="$event.stopPropagation()" ' +
          'style="width:100%;padding:8px 12px;border:none;border-bottom:1px solid #ddd;font-size:13px;outline:none;box-sizing:border-box">' +
          '</md-select-header>' +
          '<md-option ng-value="null"><em style="color:#aaa">— Cap selecció —</em></md-option>' +
          '<md-option ng-repeat="r in row.selectableRefs | filter:matchesRef track by r.id" ng-value="r.id">{{r.label}}</md-option>' +
          '</md-select>' +
          '</td>' +
          '<td style="padding:4px 8px;text-align:center;font-family:monospace;color:#555">' +
          '{{row.singleMatch ? row.refereeMatches[0].id : row.selectedRefereeId}}' +
          '</td>' +
          '<td style="padding:4px 8px;font-size:12px;color:#555;white-space:nowrap">{{row.pagament}}</td>' +
          '<td style="padding:4px 8px">' +
          '<div layout="row" layout-align="start center" style="gap:4px">' +
          '<span ng-if="row.receptorFixed" style="white-space:nowrap">{{row.receptorLabel}}</span>' +
          '<md-select ng-if="!row.receptorFixed" ng-model="row.selectedReceptorId" ' +
          'placeholder="Selecciona receptor" style="min-width:190px;margin:0" md-on-close="search.rec = \'\'">' +
          '<md-select-header>' +
          '<input ng-model="search.rec" type="search" placeholder="Cercar receptor…" ' +
          'ng-click="$event.stopPropagation()" ng-keydown="$event.stopPropagation()" ' +
          'style="width:100%;padding:8px 12px;border:none;border-bottom:1px solid #ddd;font-size:13px;outline:none;box-sizing:border-box">' +
          '</md-select-header>' +
          '<md-option ng-repeat="r in receptors | filter:matchesRec track by r.idReceptor" ng-value="r.idReceptor">{{r.nombre}}</md-option>' +
          '</md-select>' +
          '<md-button class="md-icon-button" style="margin:0;min-height:28px;min-width:28px;padding:0" ' +
          'ng-if="!row.receptorFixed && row.selectedReceptorId" ' +
          'title="Modificar receptor" ng-click="editReceptor(row)">' +
          '<md-icon style="font-size:18px;line-height:18px">edit</md-icon>' +
          '</md-button>' +
          '<md-button class="md-icon-button" style="margin:0;min-height:28px;min-width:28px;padding:0" ' +
          'title="Afegir nou receptor" ng-click="addReceptor(row)">' +
          '<md-icon style="font-size:18px;line-height:18px">add_circle_outline</md-icon>' +
          '</md-button>' +
          '</div>' +
          '</td>' +
          '<td style="padding:4px 8px;text-align:center;font-family:monospace;color:#555">' +
          '{{row.receptorFixed ? CEBLLOB_ID : row.selectedReceptorId}}' +
          '</td>' +
          '<td style="padding:4px 8px;font-size:12px;color:#555;white-space:nowrap">{{row.municipi}}</td>' +
          '<td style="padding:4px 8px;font-size:12px;color:#555;white-space:nowrap">{{row.municipiArbitr}}</td>' +
          '<td style="padding:4px 8px;text-align:center">' +
          '<input ng-model="row.distanciaFlag" ' +
          'style="width:38px;text-align:center;border:1px solid #bbb;border-radius:3px;padding:2px 4px;font-size:12px;font-family:monospace" ' +
          'title="Valor de l\'Excel. Escriu \'c\' per calcular el desplaçament automàticament" ' +
          'maxlength="4">' +
          '</td>' +
          '<td style="padding:4px 8px;text-align:center">' +
          '<md-icon ng-if="isValid(row)" style="color:#2e7d32;font-size:20px;line-height:20px">check_circle</md-icon>' +
          '<md-icon ng-if="!isValid(row)" style="color:#e53935;font-size:20px;line-height:20px">error</md-icon>' +
          '</td>' +
          '<td style="padding:4px 8px;text-align:center">' +
          '<md-button class="md-icon-button" style="margin:0;min-height:28px;min-width:28px;padding:0" title="Eliminar fila" ng-click="deleteRow(row)">' +
          '<md-icon style="font-size:18px;line-height:18px;color:#e53935">delete</md-icon>' +
          '</md-button>' +
          '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '<p style="margin:8px 0 0;font-size:11px;color:#888">' +
          '<md-icon style="font-size:13px;line-height:13px;vertical-align:middle;color:#888">info</md-icon>' +
          ' Columna <strong>Distància</strong>: el valor prové de l\'Excel i és editable. Escriu <strong>c</strong> perquè el desplaçament es calculi automàticament a partir dels municipis; qualsevol altre valor l\'ignorarà.' +
          '</p>' +
          '</md-dialog-content>' +
          '<md-dialog-actions layout="row" layout-align="space-between center" style="padding:8px 16px" ng-if="!formView && !resultsView">' +
          '<span style="color:#888;font-size:12px" ng-if="pending() > 0 && !processing">{{pending()}} files pendents de resoldre</span>' +
          '<span style="color:#2e7d32;font-size:12px" ng-if="pending() === 0 && !processing">Totes les files estan resoltes</span>' +
          '<span style="color:#1565c0;font-size:12px" ng-if="processing"><md-progress-circular md-mode="indeterminate" md-diameter="18" style="display:inline-block;vertical-align:middle;margin-right:6px"></md-progress-circular>Processant…</span>' +
          '<div>' +
          '<md-button ng-click="cancel()" ng-disabled="processing">Cancel·lar</md-button>' +
          '<md-button class="md-raised md-primary" ng-click="process()" ng-disabled="pending() > 0 || processing">Processar</md-button>' +
          '</div>' +
          '</md-dialog-actions>' +

          // ── Vista RESULTATS ───────────────────────────────────────────────
          '<md-dialog-content class="md-padding" style="overflow-x:auto;overflow-y:auto;max-height:60vh" ng-if="resultsView">' +
          '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead>' +
          '<tr style="background:#f5f5f5;border-bottom:2px solid #ddd">' +
          '<th style="padding:6px 8px;text-align:left">#</th>' +
          '<th style="padding:6px 8px;text-align:left">Nom / Cognom</th>' +
          '<th style="padding:6px 8px;text-align:left">Concepte</th>' +
          '<th style="padding:6px 8px;text-align:center">Línia</th>' +
          '<th style="padding:6px 8px;text-align:center">Desplaçament</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          '<tr ng-repeat="r in processResults" style="border-bottom:1px solid #eee" ' +
          'ng-style="{\'background\': !r.mainOk ? \'#fff8f8\' : \'\'}">' +
          '<td style="padding:4px 8px;color:#888;white-space:nowrap">{{r.row.lineNum}}</td>' +
          '<td style="padding:4px 8px;white-space:nowrap">{{r.row.nom}} {{r.row.cognom}}</td>' +
          '<td style="padding:4px 8px;font-size:12px;color:#555">{{r.esport}}</td>' +
          '<td style="padding:4px 8px;text-align:center">' +
          '<md-icon ng-if="r.mainOk" style="color:#2e7d32;font-size:20px;line-height:20px" title="OK">check_circle</md-icon>' +
          '<span ng-if="!r.mainOk" style="color:#c62828;font-size:12px" title="{{r.mainError}}">✗ {{r.mainError}}</span>' +
          '</td>' +
          '<td style="padding:4px 8px;text-align:center">' +
          '<span ng-if="r.dispKm === 0" style="color:#aaa">—</span>' +
          '<span ng-if="r.dispKm > 0 && r.dispOk" style="color:#2e7d32;font-size:12px"><md-icon style="font-size:16px;line-height:16px;vertical-align:middle;color:#2e7d32">check_circle</md-icon> {{r.dispKm}} km</span>' +
          '<span ng-if="r.dispKm > 0 && !r.dispOk" style="color:#c62828;font-size:12px" title="{{r.dispError}}">✗ {{r.dispKm}} km — {{r.dispError}}</span>' +
          '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '</md-dialog-content>' +
          '<md-dialog-actions layout="row" layout-align="space-between center" style="padding:8px 16px" ng-if="resultsView">' +
          '<span style="font-size:12px" ng-style="{color: resultErrors() > 0 ? \'#c62828\' : \'#2e7d32\'}">' +
          '{{processResults.length - resultErrors()}} de {{processResults.length}} línies OK' +
          '<span ng-if="resultErrors() > 0"> · {{resultErrors()}} amb errors</span>' +
          '</span>' +
          '<md-button class="md-raised md-primary" ng-click="closeResults()">Tancar</md-button>' +
          '</md-dialog-actions>' +

          // ── Vista FORMULARI RECEPTOR ──────────────────────────────────────
          '<md-dialog-content class="md-padding" ng-if="formView">' +
          '<form name="recForm" layout="column">' +
          '<md-input-container>' +
          '<label>Nom *</label>' +
          '<input ng-model="rec.nombre" name="nombre" required maxlength="120">' +
          '<div ng-messages="recForm.nombre.$error"><div ng-message="required">Obligatori</div></div>' +
          '</md-input-container>' +
          '<md-input-container>' +
          '<label>NIF</label>' +
          '<input ng-model="rec.nif" maxlength="20">' +
          '</md-input-container>' +
          '<md-input-container>' +
          '<label>Adreça</label>' +
          '<input ng-model="rec.direccion" maxlength="150">' +
          '</md-input-container>' +
          '<md-input-container>' +
          '<label>Adreça (línia 2)</label>' +
          '<input ng-model="rec.direccion2" maxlength="150">' +
          '</md-input-container>' +
          '<md-input-container>' +
          '<label>Telèfon</label>' +
          '<input ng-model="rec.telf" maxlength="30">' +
          '</md-input-container>' +
          '</form>' +
          '</md-dialog-content>' +
          '<md-dialog-actions ng-if="formView">' +
          '<md-button ng-click="cancelForm()">Cancel·lar</md-button>' +
          '<md-button class="md-raised md-primary" ng-click="saveForm()" ng-disabled="recForm.$invalid || saving">Desar</md-button>' +
          '</md-dialog-actions>' +

          '</md-dialog>',

        controller: function ($scope, $mdDialog) {
          $scope.rows           = rowModels;
          $scope.receptors      = allRecs;
          $scope.search         = { ref: '', rec: '' };
          $scope.matchesRef     = function (r) {
            if (!$scope.search.ref) { return true; }
            var q    = norm($scope.search.ref).replace(/\s+/g, '');
            var full = (r.normName + r.normSurname).replace(/\s+/g, '');
            return full.indexOf(q) !== -1;
          };
          $scope.matchesRec     = function (r) {
            if (!$scope.search.rec) { return true; }
            var q = norm($scope.search.rec).replace(/\s+/g, '');
            var n = norm(r.nombre).replace(/\s+/g, '');
            return n.indexOf(q) !== -1;
          };
          $scope.CEBLLOB_ID     = CEBLLOB_RECEPTOR_ID;
          $scope.formView       = false;
          $scope.resultsView    = false;
          $scope.processResults = [];
          $scope.isNewRec       = false;
          $scope.saving         = false;
          $scope.rec            = {};
          var formTargetRow     = null;

          $scope.isValid = function (row) {
            var refOk = row.singleMatch !== null ||
                        (row.selectedRefereeId !== null && row.selectedRefereeId !== undefined);
            var recOk = row.receptorFixed ||
                        (row.selectedReceptorId !== null && row.selectedReceptorId !== undefined);
            return refOk && recOk;
          };

          $scope.deleteRow = function (row) {
            var idx = $scope.rows.indexOf(row);
            if (idx > -1) { $scope.rows.splice(idx, 1); }
          };

          $scope.pending = function () {
            return $scope.rows.filter(function (r) { return !$scope.isValid(r); }).length;
          };

          $scope.processing = false;

          $scope.process = function () {
            if ($scope.pending() > 0 || $scope.processing) { return; }
            $scope.processing = true;

            var rowPromises = $scope.rows.map(function (row) { return saveRow(row); });

            $q.all(rowPromises).then(function (results) {
              $scope.processing     = false;
              $scope.processResults = results;
              $scope.resultsView    = true;
            });
          };

          // Sempre resol (mai rebutja) — retorna un objecte de resultat per fila
          function saveRow(row) {
            var refereeId  = row.singleMatch ? row.refereeMatches[0].id : row.selectedRefereeId;
            var receptorId = row.receptorFixed ? CEBLLOB_RECEPTOR_ID : row.selectedReceptorId;
            var fechaFmt   = parseExcelDate(row.fecha).format('YYYY-MM-DD');
            var esport     = 'Arbitratge ' + row.modalitat + ' competició JJEE de ' + row.municipiArbitr;

            var result = {
              row:       row,
              esport:    esport,
              mainOk:    false,
              mainError: null,
              dispKm:    0,
              dispOk:    null,
              dispError: null
            };

            var mainPayload = {
              idref:      String(refereeId),
              fecha:      fechaFmt,
              esport:     esport,
              numpartits: row.numPartits,
              preu:       row.preu,
              sinirpf:    '0',
              sintexto:   '1',
              idreceptor: receptorId
            };

            var apiUrl = EnvironmentConfig.API + '/invoiceref/' + refereeId;

            return $http.post(apiUrl, mainPayload).then(function () {
              result.mainOk = true;

              var km;
              if (/^c$/i.test(row.distanciaFlag)) {
                km = lookupDistKm(row.municipi, row.municipiArbitr, distMtx);
              } else {
                var parsed = parseFloat(String(row.distanciaFlag || '').replace(',', '.'));
                km = isNaN(parsed) ? 0 : parsed;
              }
              if (km <= 0) { return result; }

              result.dispKm = km;
              var dispPayload = {
                idref:      String(refereeId),
                fecha:      fechaFmt,
                esport:     'Desplaçament de ' + row.municipi + ' a ' + row.municipiArbitr,
                numpartits: String(km),
                preu:       String(tarifes.pricePerKm || '0'),
                sinirpf:    '1',
                sintexto:   '1',
                idreceptor: receptorId
              };

              return $http.post(apiUrl, dispPayload).then(function () {
                result.dispOk = true;
                return result;
              }, function () {
                return result;
              });

            }, function (err) {
              result.mainOk    = false;
              result.mainError = err && err.data && err.data.message ? err.data.message : 'Error al servidor';
              return result;
            });
          }

          $scope.resultErrors = function () {
            return $scope.processResults.filter(function (r) {
              return !r.mainOk;
            }).length;
          };

          $scope.closeResults = function () {
            $mdDialog.hide($scope.processResults.length);
            if (typeof loadPendingCount === 'function') {
              loadPendingCount();
                              } 
          };

          $scope.cancel = function () { $mdDialog.cancel(); };

          // ── Obrir formulari de receptor (inline, sense diàleg anidado) ────
          $scope.addReceptor = function (row) {
            formTargetRow   = row;
            $scope.isNewRec = true;
            $scope.rec      = {};
            $scope.formView = true;
          };

          $scope.editReceptor = function (row) {
            var current = null;
            for (var i = 0; i < $scope.receptors.length; i++) {
              if ($scope.receptors[i].idReceptor === row.selectedReceptorId) {
                current = $scope.receptors[i];
                break;
              }
            }
            if (!current) { return; }
            formTargetRow   = row;
            $scope.isNewRec = false;
            $scope.rec      = angular.copy(current);
            $scope.formView = true;
          };

          $scope.cancelForm = function () {
            $scope.formView = false;
          };

          $scope.saveForm = function () {
            $scope.saving = true;
            var op = $scope.isNewRec
              ? receptores.save($scope.rec).$promise
              : receptores.update({ id: $scope.rec.idReceptor }, $scope.rec).$promise;
            op.then(function (saved) {
              var idx = -1;
              for (var i = 0; i < $scope.receptors.length; i++) {
                if ($scope.receptors[i].idReceptor === saved.idReceptor) { idx = i; break; }
              }
              if (idx >= 0) {
                $scope.receptors[idx] = saved;
              } else {
                $scope.receptors.push(saved);
                $scope.receptors.sort(function (a, b) {
                  return String(a.nombre).localeCompare(String(b.nombre), 'ca');
                });
              }
              if (formTargetRow && !formTargetRow.receptorFixed) {
                formTargetRow.selectedReceptorId = saved.idReceptor;
              }
              $scope.saving   = false;
              $scope.formView = false;
            }, function () {
              $scope.saving = false;
            });
          };
        }
      }).then(function (count) {
        alertDialog('Processat', count + ' files processades correctament.');
      });
    }

    function showErrors(sheetName, errors) {
      var rows = errors.map(function (e) {
        return '<tr style="border-bottom:1px solid #eee">' +
          '<td style="padding:5px 10px;font-family:monospace;color:#555">' + e.col + '</td>' +
          '<td style="padding:5px 10px;text-align:center;color:#555">' + e.pos + '</td>' +
          '<td style="padding:5px 10px">' + escHtml(e.expected) + '</td>' +
          '<td style="padding:5px 10px;color:#c62828;font-weight:500">' + escHtml(e.actual) + '</td>' +
          '</tr>';
      }).join('');

      $mdDialog.show({
        template:
          '<md-dialog style="max-width:680px;width:90vw">' +
          '<md-toolbar class="md-warn"><div class="md-toolbar-tools">' +
          '<md-icon>error_outline</md-icon>' +
          '<h2 style="margin-left:8px">Capçaleres incorrectes — ' +
          errors.length + ' error' + (errors.length > 1 ? 's' : '') + '</h2>' +
          '</div></md-toolbar>' +
          '<md-dialog-content class="md-padding" style="overflow-x:auto">' +
          '<p style="margin-bottom:12px">Full: <strong>' + escHtml(sheetName) + '</strong></p>' +
          '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead><tr style="background:#f5f5f5;border-bottom:2px solid #ddd">' +
          '<th style="padding:6px 10px;text-align:left">Cel·la</th>' +
          '<th style="padding:6px 10px;text-align:center">Pos.</th>' +
          '<th style="padding:6px 10px;text-align:left">Capçalera esperada</th>' +
          '<th style="padding:6px 10px;text-align:left;color:#c62828">Valor trobat</th>' +
          '</tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
          '</table>' +
          '</md-dialog-content>' +
          '<md-dialog-actions>' +
          '<md-button ng-click="close()" class="md-primary md-raised">Tancar</md-button>' +
          '</md-dialog-actions>' +
          '</md-dialog>',
        controller: function ($scope, $mdDialog) {
          $scope.close = function () { $mdDialog.hide(); };
        }
      });
    }

    // ─── Emetre Factures ─────────────────────────────────────────────────────

    vm.pendingCount    = 0;
    vm.hasPendingLines = false;

    function loadPendingCount() {
      $http.get(EnvironmentConfig.API + '/invoiceref/pending').then(function (resp) {
        vm.pendingCount    = (resp.data || []).length;
        vm.hasPendingLines = vm.pendingCount > 0;
      }, function () {
        vm.pendingCount    = 0;
        vm.hasPendingLines = false;
      });
    }
    loadPendingCount();

    vm.emetreFactures = function () {
      $q.all({
        lines: $http.get(EnvironmentConfig.API + '/invoiceref/pending'),
        recs:  receptores.query().$promise
      }).then(function (data) {
        showPendingLinesDialog(data.lines.data || [], data.recs || [], AclService.isAdmin(), townHalls)
          .then(loadPendingCount, loadPendingCount);
      });
    };

    function showPendingLinesDialog(lines, allRecs, isAdmin, allTownHalls) {
      return $mdDialog.show({
        template:
          '<md-dialog style="max-width:1100px;width:97vw">' +

          // ── Toolbar ───────────────────────────────────────────────────────
          '<md-toolbar><div class="md-toolbar-tools">' +
          '<md-icon>{{editView ? "edit" : "receipt"}}</md-icon>' +
          '<h2 style="margin-left:8px" ng-if="!editView">Línies pendents d\'emetre ({{lines.length}})</h2>' +
          '<h2 style="margin-left:8px" ng-if="editView">Editar línia</h2>' +
          '<span flex></span>' +
          '</div></md-toolbar>' +

          // ── Vista LLISTA ──────────────────────────────────────────────────
          '<md-dialog-content class="md-padding" style="overflow-x:auto;overflow-y:auto;max-height:65vh" ng-if="!editView">' +
          '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead>' +
          '<tr style="background:#f5f5f5;border-bottom:2px solid #ddd">' +
          '<th style="padding:6px 8px">' +
          '<md-checkbox ng-model="ui.allSelected" ng-change="toggleAll()" aria-label="Seleccionar totes"></md-checkbox>' +
          '</th>' +
          '<th style="padding:6px 8px;text-align:left">Data</th>' +
          '<th style="padding:6px 8px;text-align:left">Nom / Cognom</th>' +
          '<th style="padding:6px 8px;text-align:left">Concepte</th>' +
          '<th style="padding:6px 8px;text-align:center">Partits</th>' +
          '<th style="padding:6px 8px;text-align:right">Preu</th>' +
          '<th style="padding:6px 8px;text-align:left">Receptor</th>' +
          '<th style="padding:6px 8px;text-align:center">Accions</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          '<tr ng-repeat="line in lines" style="border-bottom:1px solid #eee" ' +
          'ng-style="{background: line.selected ? \'#e8f5e9\' : \'\'}">' +
          '<td style="padding:4px 8px">' +
          '<md-checkbox ng-model="line.selected" aria-label="Seleccionar línia"></md-checkbox>' +
          '</td>' +
          '<td style="padding:4px 8px;white-space:nowrap">{{line.fecha}}</td>' +
          '<td style="padding:4px 8px;white-space:nowrap">{{line.cognom1}} {{line.nom}}</td>' +
          '<td style="padding:4px 8px;font-size:12px">{{line.esport}}</td>' +
          '<td style="padding:4px 8px;text-align:center">{{line.numpartits}}</td>' +
          '<td style="padding:4px 8px;text-align:right">{{line.preu | number:2}} €</td>' +
          '<td style="padding:4px 8px;font-size:12px">{{receptorName(line.idreceptor)}}</td>' +
          '<td style="padding:4px 8px;text-align:center;white-space:nowrap">' +
          '<md-button class="md-icon-button" style="margin:0;min-width:32px;min-height:32px;padding:0" ' +
          'ng-click="startEdit(line)" title="Editar">' +
          '<md-icon style="font-size:18px;line-height:18px">edit</md-icon>' +
          '</md-button>' +
          '<md-button class="md-icon-button" style="margin:0;min-width:32px;min-height:32px;padding:0" ' +
          'ng-click="deleteLine(line)" title="Esborrar">' +
          '<md-icon style="font-size:18px;line-height:18px;color:#e53935">delete</md-icon>' +
          '</md-button>' +
          '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '<span ng-if="lines.length === 0" style="color:#888;font-size:13px">No hi ha línies pendents.</span>' +
          '</md-dialog-content>' +
          '<md-dialog-actions layout="row" layout-align="space-between center" style="padding:8px 16px" ng-if="!editView">' +
          '<span style="font-size:12px;color:#555">{{selectedCount()}} de {{lines.length}} seleccionades</span>' +
          '<div>' +
          '<md-button ng-click="close()">Tancar</md-button>' +
          '<md-button class="md-raised md-primary" ng-click="emetre()" ' +
          'ng-disabled="selectedCount() === 0 || emitting">Emetre seleccionades</md-button>' +
          '</div>' +
          '</md-dialog-actions>' +

          // ── Vista EDITAR LÍNIA ────────────────────────────────────────────
          '<md-dialog-content class="md-padding" ng-if="editView">' +
          '<form name="lineForm" layout="column">' +
          '<div layout="row" layout-wrap>' +
          '<md-input-container flex="30" flex-sm="100">' +
          '<label>Data</label>' +
          '<input type="date" ng-model="editLine.fecha" name="fecha" required>' +
          '</md-input-container>' +
          '<md-input-container flex="70" flex-sm="100">' +
          '<label>Concepte</label>' +
          '<input ng-model="editLine.esport" name="esport" required maxlength="200">' +
          '</md-input-container>' +
          '</div>' +
          '<div layout="row" layout-wrap>' +
          '<md-input-container flex="25" flex-sm="50">' +
          '<label>Núm. partits / km</label>' +
          '<input type="number" ng-model="editLine.numpartits" name="numpartits" min="0" required>' +
          '</md-input-container>' +
          '<md-input-container flex="25" flex-sm="50">' +
          '<label>Preu brut (€)</label>' +
          '<input type="number" step="0.01" ng-model="editLine.preu" name="preu" min="0" required>' +
          '</md-input-container>' +
          '<md-input-container flex="40" flex-sm="100">' +
          '<label>Receptor</label>' +
          '<md-select ng-model="editLine.idreceptor" name="idreceptor" required>' +
          '<md-option ng-repeat="r in receptors" ng-value="r.idReceptor">{{r.nombre}}</md-option>' +
          '</md-select>' +
          '</md-input-container>' +
          '</div>' +
          '<div layout="row">' +
          '<md-checkbox ng-model="editLine.sinirpf" flex>Sense IRPF</md-checkbox>' +
          '<md-checkbox ng-model="editLine.sintexto" flex>Sense text</md-checkbox>' +
          '</div>' +
          '</form>' +
          '</md-dialog-content>' +
          '<md-dialog-actions ng-if="editView">' +
          '<md-button ng-click="cancelEdit()">Cancel·lar</md-button>' +
          '<md-button class="md-raised md-primary" ng-click="saveLine()" ' +
          'ng-disabled="lineForm.$invalid || saving">Desar</md-button>' +
          '</md-dialog-actions>' +

          '</md-dialog>',

        controller: function ($scope, $mdDialog, $timeout) {
          $scope.lines    = lines;
          $scope.receptors = allRecs;
          $scope.editView  = false;
          $scope.ui = {allSelected: false};
          $scope.saving    = false;
          $scope.emitting  = false;
          var editTarget   = null;

          $scope.receptorName = function (id) {
            for (var i = 0; i < $scope.receptors.length; i++) {
              if ($scope.receptors[i].idReceptor === id) { return $scope.receptors[i].nombre; }
            }
            return id;
          };

          $scope.toggleAll = function () {
            var val = $scope.ui.allSelected;
            $scope.lines.forEach(function (l) {
              l.selected = val;
            });
          };

          $scope.selectedCount = function () {
            return $scope.lines.filter(function (l) { return l.selected; }).length;
          };

          // ── Editar ────────────────────────────────────────────────────────
          function parseDateLocal(s) {
            var p = s ? String(s).split('-') : null;
            if (!p) {
              return null;
            }
            return new Date(+p[0], +p[1] - 1, +p[2]);
          }

          function formatDateYMD(d) {
            if (!d) {
              return null;
            }
            return [d.getFullYear(),
                    ('0' + (d.getMonth() + 1)).slice(-2),
                    ('0' + d.getDate()).slice(-2)].join('-');
          }

          $scope.startEdit = function (line) {
            editTarget = line;
            $scope.editLine = {
              id:         line.id,
              fecha:      parseDateLocal(line.fecha),
              esport:     line.esport,
              numpartits: Number(line.numpartits),
              preu:       Number(line.preu),
              sinirpf:    line.sinirpf === '1' || line.sinirpf === 1,
              sintexto:   line.sintexto === '1' || line.sintexto === 1,
              idreceptor: line.idreceptor
            };
            $scope.editView = true;
          };

          $scope.cancelEdit = function () { $scope.editView = false; };

          $scope.saveLine = function () {
            var fechaStr, payload;
            $scope.saving = true;
            fechaStr = formatDateYMD($scope.editLine.fecha);
            payload = {
              id:         $scope.editLine.id,
              idref:      editTarget.idRef || editTarget.idref,
              fecha:      fechaStr,
              esport:     $scope.editLine.esport,
              numpartits: String($scope.editLine.numpartits),
              preu:       String($scope.editLine.preu),
              sinirpf:    $scope.editLine.sinirpf ? '1' : '0',
              sintexto:   $scope.editLine.sintexto ? '1' : '0',
              idreceptor: $scope.editLine.idreceptor
            };
            $http.put(EnvironmentConfig.API + '/invoicerefline/' + payload.id, payload)
              .then(function () {
                angular.extend(editTarget, {
                  fecha:      fechaStr,
                  esport:     payload.esport,
                  numpartits: payload.numpartits,
                  preu:       payload.preu,
                  sinirpf:    payload.sinirpf,
                  sintexto:   payload.sintexto,
                  idreceptor: payload.idreceptor
                });
                $scope.saving = false;
                $scope.editView = false;
              }, function () {
                $scope.saving = false;
              });
          };

          // ── Esborrar ──────────────────────────────────────────────────────
 $scope.deleteLine = function (line) {
  if (!window.confirm('Segur que vols esborrar aquesta línia?')) { return; }

  $http.delete(EnvironmentConfig.API + '/invoicerefline/' + line.id, {
    transformResponse: [function (data) {
      return data; // NO intentar parsear JSON
    }]
  })
  .then(function () {
    return $http.get(EnvironmentConfig.API + '/invoiceref/pending');
  })
  .then(function (resp) {
    $scope.lines = resp.data || [];
    $scope.ui.allSelected = false;

    if (typeof loadPendingCount === 'function') {
      loadPendingCount();
    } else {
      console.warn('loadPendingCount no definida');
    }
  })
  .catch(function (err) {
    console.error('Error en deleteLine:', err);
  });
};

          // ── Emetre ────────────────────────────────────────────────────────
          $scope.emetre = function () {
            var selected = $scope.lines.filter(function (l) { return l.selected; });
            if (selected.length === 0 || $scope.emitting) { return; }

            if (!window.showDirectoryPicker) {
              $mdToast.show($mdToast.simple()
                .textContent('El teu navegador no suporta la selecció de carpetes. Usa Chrome o Edge.')
                .position('bottom right').hideDelay(6000));
              return;
            }

            $q.when(window.showDirectoryPicker({ mode: 'readwrite' }))
              .then(function (dirHandle) {
                $scope.emitting = true;

                var groups = {};
                selected.forEach(function (l) {
                  if (!groups[l.idreceptor]) { groups[l.idreceptor] = []; }
                  groups[l.idreceptor].push(l);
                });

                var validTH = allTownHalls.filter(function (th) { return th.id; });
                var idAjunt = validTH.length > 0 ? validTH[0].id : 0;

                return Object.keys(groups).reduce(function (promise, recId) {
                  return promise.then(function (allAssignments) {
                    var grp = groups[recId];
                    var dates = grp.map(function (l) { return l.fecha; }).sort();
                    var ids = grp.map(function (l) { return l.id; }).join(',');
                    return $http.get(EnvironmentConfig.API + '/invoicesgenerate', {
                      params: {
                        initDate: dates[0],
                        endDate: dates[dates.length - 1],
                        idAjuntament: idAjunt,
                        ids: ids,
                        isAdmin: isAdmin
                      }
                    }).then(function (resp) {
                      return allAssignments.concat(resp.data || []);
                    });
                  });
                }, $q.when([]))
                  .then(function (assignments) {

                    var renamedFiles = [];

                    function tsNow() {
                      var d = new Date(), p = function (n) { return n < 10 ? '0' + n : '' + n; };
                      return '' + d.getFullYear() + p(d.getMonth()+1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes());
                    }
                    function withTimestamp(fname) {
                      var ts = tsNow(), dot = fname.lastIndexOf('.');
                      return dot === -1 ? fname + '_' + ts : fname.slice(0, dot) + '_' + ts + fname.slice(dot);
                    }

                    var pdfPromises = assignments.map(function (a) {
                      return $http.get(EnvironmentConfig.API + '/invoices/pdf', {
                        params: { personId: a.personId, numinvoice: a.numinvoice, anyo: a.anyo },
                        responseType: 'arraybuffer'
                      }).then(function (resp) {
                        var cd = resp.headers('Content-Disposition') || '';
                        var match = cd.match(/filename="([^"]+)"/);
                        var filename = match ? match[1] : (a.anyo + '_' + a.numinvoice + '.pdf');
                        var cognom = (a.cognom || '').replace(/[<>:"/\\|?*\x00-\x1f]/g, '').trim();
                        var nom    = (a.nom    || '').replace(/[<>:"/\\|?*\x00-\x1f]/g, '').trim();
                        var subfolder = cognom && nom ? (cognom + ' - ' + nom) : String(a.personId);
                        return $q.when(
                          dirHandle.getDirectoryHandle(subfolder, { create: true })
                            .then(function (subDir) {
                              return subDir.getFileHandle(filename, { create: false })
                                .then(function () {
                                  var newName = withTimestamp(filename);
                                  renamedFiles.push(filename + ' → ' + newName);
                                  return newName;
                                }, function () {
                                  return filename;
                                })
                                .then(function (finalName) {
                                  return subDir.getFileHandle(finalName, { create: true })
                                    .then(function (fh) { return fh.createWritable(); })
                                    .then(function (w) { return w.write(resp.data).then(function () { return w.close(); }); });
                                });
                            })
                        );
                      });
                    });

                    return $q.all(pdfPromises).then(function () { return { count: assignments.length, renamed: renamedFiles }; });
                  })
                  .then(function (result) {
                    $mdToast.show($mdToast.simple()
                      .textContent(result.count + ' PDF(s) generats i guardats correctament.')
                      .position('bottom right').hideDelay(5000));
                    if (result.renamed.length > 0) {
                      $timeout(function () {
                        $mdToast.show($mdToast.simple()
                          .textContent('Avís: ' + result.renamed.length + ' fitxer(s) ja existien i s\'han reanomenat amb marca de temps.')
                          .position('bottom right').hideDelay(10000));
                      }, 1500);
                    }
                    return $http.get(EnvironmentConfig.API + '/invoiceref/pending');
                  })
                  .then(function (resp) {
                    $timeout(function () {
                      $scope.lines = resp.data || [];
                      $scope.ui.allSelected = false;
                      $scope.emitting = false;
                      loadPendingCount();
                      if ($scope.lines.length === 0) { $mdDialog.hide(); }
                    });
                  });
              })
              .catch(function (err) {
                if (err && err.name === 'AbortError') { return; }
                var errMsg = err && err.data
                  ? (typeof err.data === 'string' ? err.data : (err.data.message || 'Error'))
                  : (err && err.message ? err.message : 'Error generant PDFs');
                $mdToast.show($mdToast.simple().textContent(errMsg).position('bottom right').hideDelay(6000));
                $scope.emitting = false;
              });
          };

          $scope.close = function () { $mdDialog.hide(); };
        }
      });
    }

    function alertDialog(title, msg) {
      $mdDialog.show($mdDialog.alert().title(title).textContent(msg).ok('D\'acord'));
    }

    function colLetter(i) {
      return i < 26
        ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i]
        : 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(i / 26) - 1] +
          'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i % 26];
    }

    function escHtml(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
  }
}());
